import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <Section tone="navy" data-id="element-84" data-mp="1clzdynwxay5j">
      <SectionTitle tone="dark" eyebrow="Free with your order" data-id="element-85" data-mp="1cj3fmyh5y7gk">
        Plus You'll Receive These 5 Exclusive Bonuses{' '}
        <span className="text-gold" data-id="element-86" data-mp="259lf7piohqp8">FREE</span>
      </SectionTitle>

      <div className="mt-8 space-y-5" data-id="element-87" data-mp="25925ux73gamt">
        {bonuses.map(bonus => <article key={bonus.number} className="overflow-hidden rounded-3xl border border-white/12 bg-white/[0.06] p-5 sm:p-6" data-id="element-88" data-mp="20c21cqpw7fxt">
            <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] text-gold" data-id="element-89" data-mp="1ralpsfncd7s0">
              <GiftIcon className="h-4 w-4" data-id="element-90" data-mp="ku9z0zmums6g" />
              {bonus.number}
            </p>
            <h3 className="mt-2 font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-91" data-mp="fudw73pw16sh">
              {bonus.title}
            </h3>

            {bonus.image ? <img src={bonus.image} alt={bonus.title} className="mt-4 w-full rounded-2xl bg-white" data-id="element-92" data-mp="1jsrhor1ecv9f" /> : null}

            <p className="mt-4 text-[14.5px] font-semibold leading-snug text-white/90" data-id="element-93" data-mp="15vbbngn0j3i7">
              {bonus.lead}
            </p>
            {bonus.body ? <p className="mt-2 text-[14px] leading-relaxed text-white/65" data-id="element-94" data-mp="w2dqt3ujt2gf">
                {bonus.body}
              </p> : null}

            {bonus.items ? <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-95" data-mp="n3a4zs3zy8y8">
                {bonus.items.map(item => <li key={item} className="flex items-start gap-2 text-[14px] leading-snug text-white/85" data-id="element-96" data-mp="r544hx2gh6wt">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-97" data-mp="i34lx0bslurr" />
                    {item}
                  </li>)}
              </ul> : null}

            <p className="mt-4 inline-block rounded-full bg-gold/15 px-3 py-1.5 text-[12px] font-bold uppercase tracking-wide text-gold" data-id="element-98" data-mp="2juele9w15xst">
              Retail value: {bonus.value}
            </p>
          </article>)}
      </div>

      <CTAButton className="mt-8" variant="gold" label="Claim my 5 free bonuses" data-id="element-99" data-mp="261yc4rcjd3jg" />
      <p className="mt-3 text-center text-[13px] text-white/60" data-id="element-100" data-mp="32qea9btpol86">
        $295 in bonuses included at no extra cost
      </p>
    </Section>;
}